import { connect } from 'react-redux';
import { showMockupsSelector } from '../../../redux/show-mockups/show-mockups.selectors';
import { showMockupsDispatcher } from '../../../redux/show-mockups/show-mockups.dispatcher';
import OpenImagePopup from './open-image-popup';
export default connect(showMockupsSelector, showMockupsDispatcher)(OpenImagePopup);